import React from "react";
import CompanyInfoPageGen from "./generated/CompanyInfoPageGen";
import companyInfoService from "../../../services/legacy/companyInfoService";



const CompanyInfoPage = () => {
  const service = companyInfoService;
  return <CompanyInfoPageGen service={service} />;
};

export default CompanyInfoPage;